import '../styles/spinner.css';
import spinner from '/spinner.svg';

export default function Spinner() {
  return (
    <div className="spinner">
      <img
        src={spinner}
        alt="spinner"
        className="spinner__img"
      />
    </div>
  );
}
